import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import imageEight from "./8.png";
import imageNine from "./9.gif";
import imageEleven from "./11.jpeg";
import imageTwelve from "./12.jpeg";
import imageThirteen from "./13.jpeg";
import ltc from "./ltc.mp4";
import imageFourteen from "./14.jpeg";
import QuantawindVideo from "./QwVideo1.mp4";

const SnapShotHome = () => {
  return (
    <>
      <style>{`
        .snapshot-carousel .react-multi-carousel-list {
          padding-bottom: 35px !important;
        }
        .snapshot-dots {
          bottom: auto !important;
          top: 60% !important;
        }
      `}</style>
      <Carousel
      additionalTransfrom={0}
      arrows
      autoPlaySpeed={3000}
      centerMode={true}
      className=""
      containerClass="container snapshot-carousel"
      dotListClass="snapshot-dots"
      draggable
      focusOnSelect={false}
      infinite
      itemClass="px-3"
      keyBoardControl
      minimumTouchDrag={80}
      pauseOnHover
      renderArrowsWhenDisabled={false}
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      responsive={{
        desktop: {
          breakpoint: {
            max: 3000,
            min: 1024,
          },
          items: 1,
        },
        mobile: {
          breakpoint: {
            max: 464,
            min: 0,
          },
          items: 1,
        },
        tablet: {
          breakpoint: {
            max: 1024,
            min: 464,
          },
          items: 1,
        },
      }}
      rewind={false}
      rewindWithAnimation={false}
      rtl={false}
      shouldResetAutoplay
      showDots
      sliderClass=""
      slidesToSlide={1}
      swipeable
    >
      <video
        src={QuantawindVideo}
        autoPlay
        muted
        loop
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      ></video>
      <video
        src={`${process.env.PUBLIC_URL}/product/cfd.mp4`}
        autoPlay
        muted
        loop
        playsInline
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      ></video>
      <video
        src={`${process.env.PUBLIC_URL}/product/contour.mp4`}
        autoPlay
        muted
        loop
        playsInline
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      ></video>
      <video
        src={`${process.env.PUBLIC_URL}/product/ms.mp4`}
        autoPlay
        muted
        loop
        playsInline
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      ></video>
      <video
        src={ltc}
        autoPlay
        muted
        loop
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      ></video>

      <video
        src={`${process.env.PUBLIC_URL}/product/linkedin-video.mp4`}
        autoPlay
        muted
        loop
        playsInline
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      ></video>
      <video
        src={`${process.env.PUBLIC_URL}/product/linkedin-video2.mp4`}
        autoPlay
        muted
        loop
        playsInline
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      ></video>
      <img
        src={imageTwelve}
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      />
      <img
        src={imageFourteen}
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      />

      {/* <img
        src={imageEight}
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      />
      <img
        src={imageNine}
        style={{
          display: "block",
          height: "60%",
          margin: "auto",
          width: "100%",
        }}
      /> */}
    </Carousel>
    </>
  );
};

export default SnapShotHome;
